import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type storeIdState = {
  storeIdState: string | null;
};

const initialState: storeIdState = {
  storeIdState: null,
};

export const storeIdStateSlice = createSlice({
  name: "storeIdState",
  initialState,
  reducers: {
    setStoreIdState: (state, action: PayloadAction<string>) => {
      state.storeIdState = action.payload;
    },
  },
});

export const { setStoreIdState } = storeIdStateSlice.actions;

export default storeIdStateSlice.reducer;
